import { useState, useRef, useEffect, useCallback } from "react";
import axios from "axios";

const BASE_URL = "https://dr-mohamed-khaled.site";
const DOCTOR_ID = "5b075375-0b21-4e67-91c8-1ab2c709fa85";

const styles = {
  wrapper: {
    position: "fixed",
    bottom: "29px",
    right: "24px",
    zIndex: 9999,
    fontFamily: "sans-serif",
    direction: "rtl",
  },
  tooltip: {
    position: "absolute",
    bottom: "70px",
    right: "0",
    background: "#1a1a2e",
    color: "#C9A84C",
    fontSize: "12px",
    padding: "6px 14px",
    borderRadius: "20px",
    whiteSpace: "nowrap",
    border: "1px solid rgba(201,168,76,0.3)",
    pointerEvents: "none",
  },
  panel: {
    position: "absolute",
    bottom: "80px",
    right: "0",
    width: "320px",
    background: "#12121f",
    borderRadius: "16px",
    overflow: "hidden",
    border: "1px solid rgba(201,168,76,0.25)",
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 8px 32px rgba(0,0,0,0.4)",
  },
  header: {
    background: "#C9A84C",
    padding: "14px 16px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  avatar: {
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    background: "#1a1a2e",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "18px",
    color: "#C9A84C",
  },
  headerInfo: { flex: 1 },
  headerTitle: { fontSize: "14px", fontWeight: "600", color: "#1a1a2e" },
  headerSub: {
    fontSize: "11px",
    color: "#3a3010",
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  onlineDot: {
    width: "7px",
    height: "7px",
    borderRadius: "50%",
    background: "#2e7d32",
    display: "inline-block",
  },
  closeBtn: {
    background: "none",
    border: "none",
    cursor: "pointer",
    color: "#1a1a2e",
    fontSize: "20px",
    lineHeight: 1,
    padding: "2px",
  },
  messages: {
    flex: 1,
    padding: "16px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    minHeight: "200px",
    maxHeight: "240px",
    overflowY: "auto",
  },
  msgSupport: {
    maxWidth: "80%",
    padding: "8px 12px",
    borderRadius: "12px 12px 12px 2px",
    fontSize: "13px",
    lineHeight: "1.5",
    background: "#1e1e35",
    color: "#e0d5b0",
    alignSelf: "flex-start",
    textAlign: "right",
  },
  msgUser: {
    maxWidth: "80%",
    padding: "8px 12px",
    borderRadius: "12px 12px 2px 12px",
    fontSize: "13px",
    lineHeight: "1.5",
    background: "#C9A84C",
    color: "#1a1a2e",
    fontWeight: "500",
    alignSelf: "flex-end",
    textAlign: "right",
  },
  msgError: {
    maxWidth: "80%",
    padding: "8px 12px",
    borderRadius: "12px",
    fontSize: "12px",
    lineHeight: "1.5",
    background: "#2a0a0a",
    color: "#ff6b6b",
    alignSelf: "center",
    textAlign: "center",
    border: "1px solid rgba(255,107,107,0.3)",
  },
  registrationScreen: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "24px 20px",
    gap: "16px",
    background: "#12121f",
  },
  registrationTitle: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#C9A84C",
    textAlign: "center",
    marginBottom: "4px",
  },
  registrationSub: {
    fontSize: "12px",
    color: "#8a7f6b",
    textAlign: "center",
    marginBottom: "8px",
  },
  fieldLabel: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    width: "100%",
    fontSize: "12px",
    color: "#e0d5b0",
    textAlign: "right",
  },
  fieldInput: {
    background: "#1a1a2e",
    border: "1px solid rgba(201,168,76,0.2)",
    borderRadius: "12px",
    padding: "10px 14px",
    fontSize: "13px",
    color: "#e0d5b0",
    outline: "none",
    direction: "rtl",
    fontFamily: "sans-serif",
    width: "100%",
    boxSizing: "border-box",
    transition: "border-color 0.2s",
  },
  startBtn: {
    width: "100%",
    padding: "11px",
    borderRadius: "12px",
    background: "#C9A84C",
    border: "none",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "600",
    color: "#1a1a2e",
    marginTop: "4px",
    transition: "opacity 0.2s",
  },
  startBtnDisabled: {
    opacity: 0.45,
    cursor: "not-allowed",
  },
  inputRow: {
    padding: "10px 12px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    borderTop: "1px solid rgba(201,168,76,0.15)",
    background: "#0e0e1a",
  },
  input: {
    flex: 1,
    background: "#1a1a2e",
    border: "1px solid rgba(201,168,76,0.2)",
    borderRadius: "20px",
    padding: "8px 14px",
    fontSize: "13px",
    color: "#e0d5b0",
    outline: "none",
    direction: "rtl",
    fontFamily: "sans-serif",
  },
  sendBtn: {
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    background: "#C9A84C",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    fontSize: "18px",
    color: "#1a1a2e",
  },
  sendBtnDisabled: {
    background: "#3a3a3a",
    cursor: "not-allowed",
    opacity: 0.5,
  },
  chatBtn: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    background: "#C9A84C",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: "0 4px 16px rgba(0,0,0,0.35)",
    fontSize: "28px",
    color: "#1a1a2e",
    transition: "transform 0.2s, background 0.2s",
  },
  loadingDots: {
    display: "flex",
    gap: "4px",
    alignSelf: "flex-start",
    padding: "10px 14px",
    background: "#1e1e35",
    borderRadius: "12px 12px 12px 2px",
  },
  dot: {
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    background: "#C9A84C",
    animation: "bounce 1.2s infinite ease-in-out",
  },
};

const styleEl = document.createElement("style");
styleEl.textContent = `
  @keyframes bounce {
    0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
    40% { transform: scale(1); opacity: 1; }
  }
`;
document.head.appendChild(styleEl);

// Normalize raw API messages into our shape
const normalizeMessages = (raw) =>
  raw.map((m) => ({
    id: m.id ?? m._id ?? String(Math.random()),
    from: m.senderType === "patient" ? "user"
         : m.senderType === "doctor" || m.senderType === "support" || m.senderType === "assistant" ? "support"
         : m.sender_type === "patient" ? "user"
         : m.sender_type === "doctor" || m.sender_type === "support" ? "support"
         : m.role === "patient" || m.role === "user" ? "user"
         : "support",
    text: m.message ?? m.text ?? "",
  }));

export default function LiveChatWidget() {
  const [open, setOpen] = useState(false);
  const [phase, setPhase] = useState("register"); // "register" | "chat"
  const [messages, setMessages] = useState([]); // API is the only source of truth
  const [inputVal, setInputVal] = useState("");
  const [patientName, setPatientName] = useState("");
  const [patientPhone, setPatientPhone] = useState("");
  const [roomId, setRoomId] = useState(null);
  const [isCreatingRoom, setIsCreatingRoom] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);
  const pollRef = useRef(null);

  // ── Scroll to bottom on new messages ────────────────────────────
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, isLoading]);

  useEffect(() => {
    if (open && phase === "chat" && inputRef.current) {
      setTimeout(() => inputRef.current.focus(), 100);
    }
  }, [open, phase]);

  // ── Fetch & replace messages from API (single source of truth) ──
  const fetchRoomMessages = useCallback(async (id) => {
    if (!id) return;
    try {
      const { data } = await axios.get(`${BASE_URL}/api/chat/rooms/${id}`);
      const raw =
        data?.room?.messages ||
        data?.messages ||
        data?.data?.messages ||
        [];
      if (!Array.isArray(raw)) return;
      console.log("📨 raw messages from API:", JSON.stringify(raw, null, 2));
      setMessages(normalizeMessages(raw));
    } catch (_) {
      // silent on poll errors
    }
  }, []);

  // ── Poll every 4s once in chat phase ────────────────────────────
  useEffect(() => {
    if (roomId && phase === "chat") {
      pollRef.current = setInterval(() => fetchRoomMessages(roomId), 4000);
    }
    return () => clearInterval(pollRef.current);
  }, [roomId, phase, fetchRoomMessages]);

  // ── Helper: find existing room by phone number ───────────────────
  const findExistingRoom = async (phone) => {
    try {
      const { data } = await axios.get(`${BASE_URL}/api/chat/rooms`);
      const rooms =
        data?.rooms ?? data?.data ?? (Array.isArray(data) ? data : []);
      const match = rooms.find(
        (r) => r.patient_phone === phone && r.doctor_id === DOCTOR_ID
      );
      return match?.id ?? match?._id ?? null;
    } catch (_) {
      return null;
    }
  };

  // ── Step 1: Create room (or resume existing) ─────────────────────
  const handleStartChat = async () => {
    const name = patientName.trim();
    const phone = patientPhone.trim();
    if (!name || !phone) return;

    setIsCreatingRoom(true);
    try {
      let id = null;

      try {
        const { data } = await axios.post(`${BASE_URL}/api/chat/rooms/`, {
          doctor_id: DOCTOR_ID,
          patient_name: name,
          patient_phone: phone,
        });
        id = data?.room?.id ?? data?.id ?? data?.data?.id;
      } catch (postErr) {
        const isDuplicate =
          postErr?.response?.data?.error?.toLowerCase().includes("duplicate") ||
          postErr?.response?.status === 409 ||
          postErr?.response?.status === 400;

        if (isDuplicate) {
          id = await findExistingRoom(phone);
        }
      }

      if (!id) throw new Error("Could not get room ID");

      setRoomId(id);
      setPhase("chat");
      // Fetch real messages from API immediately — no local placeholders
      await fetchRoomMessages(id);
    } catch (err) {
      setMessages([{
        id: "err-" + Date.now(),
        from: "error",
        text: "تعذّر الاتصال. تحقق من اتصالك وحاول مجدداً.",
      }]);
    } finally {
      setIsCreatingRoom(false);
    }
  };

  // ── Step 2: Send message ─────────────────────────────────────────
  const sendMessage = async () => {
    const text = inputVal.trim();
    if (!text || !roomId || isSending) return;

    setInputVal("");
    setIsSending(true);
    setIsLoading(true);

    try {
      await axios.post(`${BASE_URL}/api/chat/messages`, {
        roomId,
        senderType: "patient",
        message: text,
      });
      // Fetch fresh messages from API — replaces everything cleanly
      await fetchRoomMessages(roomId);
    } catch (_) {
      setMessages((prev) => [
        ...prev,
        {
          id: "err-" + Date.now(),
          from: "error",
          text: "فشل إرسال الرسالة. حاول مجدداً.",
        },
      ]);
    } finally {
      setIsSending(false);
      setIsLoading(false);
    }
  };

  const canStart = patientName.trim().length > 0 && patientPhone.trim().length > 0;

  return (
    <div style={styles.wrapper}>
      {open && (
        <div style={styles.panel}>
          {/* Header */}
          <div style={styles.header}>
            <div style={styles.avatar}>💬</div>
            <div style={styles.headerInfo}>
              <div style={styles.headerTitle}>الدعم الفني</div>
              <div style={styles.headerSub}>
                <span style={styles.onlineDot} />
                متاح الآن
              </div>
            </div>
            <button
              style={styles.closeBtn}
              onClick={() => setOpen(false)}
              aria-label="إغلاق"
            >
              ✕
            </button>
          </div>

          {/* ── REGISTER PHASE ── */}
          {phase === "register" && (
            <div style={styles.registrationScreen}>
              <div>
                <div style={styles.registrationTitle}>ابدأ المحادثة</div>
                <div style={styles.registrationSub}>
                  أدخل بياناتك لنتمكن من مساعدتك
                </div>
              </div>

              <label style={styles.fieldLabel}>
                الاسم الكامل
                <input
                  style={styles.fieldInput}
                  type="text"
                  placeholder="أدخل اسمك"
                  value={patientName}
                  onChange={(e) => setPatientName(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && canStart && handleStartChat()}
                  autoFocus
                />
              </label>

              <label style={styles.fieldLabel}>
                رقم الهاتف
                <input
                  style={styles.fieldInput}
                  type="tel"
                  placeholder="01XXXXXXXXX"
                  value={patientPhone}
                  onChange={(e) => setPatientPhone(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && canStart && handleStartChat()}
                />
              </label>

              <button
                style={{
                  ...styles.startBtn,
                  ...(!canStart || isCreatingRoom ? styles.startBtnDisabled : {}),
                }}
                onClick={handleStartChat}
                disabled={!canStart || isCreatingRoom}
              >
                {isCreatingRoom ? "جارٍ الاتصال..." : "ابدأ المحادثة ←"}
              </button>
            </div>
          )}

          {/* ── CHAT PHASE ── */}
          {phase === "chat" && (
            <>
              <div style={styles.messages}>
                {messages.length === 0 && !isLoading && (
                  <div style={{ ...styles.msgSupport, opacity: 0.6 }}>
                    لا توجد رسائل بعد. ابدأ المحادثة!
                  </div>
                )}

                {messages.map((msg) => (
                  <div
                    key={msg.id}
                    style={
                      msg.from === "error"
                        ? styles.msgError
                        : msg.from === "support"
                        ? styles.msgSupport
                        : styles.msgUser
                    }
                  >
                    {msg.text}
                  </div>
                ))}

                {isLoading && (
                  <div style={styles.loadingDots}>
                    <div style={{ ...styles.dot, animationDelay: "0s" }} />
                    <div style={{ ...styles.dot, animationDelay: "0.2s" }} />
                    <div style={{ ...styles.dot, animationDelay: "0.4s" }} />
                  </div>
                )}

                <div ref={messagesEndRef} />
              </div>

              <div style={styles.inputRow}>
                <button
                  style={{
                    ...styles.sendBtn,
                    ...(isSending || !inputVal.trim() ? styles.sendBtnDisabled : {}),
                  }}
                  onClick={sendMessage}
                  aria-label="إرسال"
                  disabled={isSending || !inputVal.trim()}
                >
                  ➤
                </button>
                <input
                  ref={inputRef}
                  style={styles.input}
                  type="text"
                  placeholder="اكتب رسالتك..."
                  value={inputVal}
                  onChange={(e) => setInputVal(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !isSending) sendMessage();
                  }}
                  disabled={isSending}
                />
              </div>
            </>
          )}
        </div>
      )}

      {!open && <div style={styles.tooltip}>تواصل معنا الآن</div>}

      <button
        style={styles.chatBtn}
        onClick={() => setOpen((v) => !v)}
        aria-label={open ? "إغلاق الشات" : "فتح الشات"}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.08)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
      >
        {open ? "✕" : "💬"}
      </button>
    </div>
  );
}